export default __webpack_public_path__ + "static/media/Text-2.b9173446.png";